import React from "react";
import AboutMain from "./AboutMain";
import Footer from "../../components/Footer";
import HeaderFour from "../../components/Header/HeaderFour";

const About = () => {
  return (
    <>
      <HeaderFour />

      <AboutMain />

      <Footer />
    </>
  );
};

export default About;
